module.exports = __webpack_public_path__ + "static/media/3.20e449de.png";